import React from 'react';

import ContactList from 'Core/Components/ContactList';
import ContentController from 'RLX/Controllers/ContentController';

class ContactListEditor extends ContentController {
  static getInitialShape () {
    return {
      props: {
        list: []
      }
    }
  }

  getBlockName () {
    return 'Contact List';
  }

  getClassName () {
    return 'ContactListEditor';
  }

  getFields () {
    const { content } = this.props;
    return [
      {
        type: 'ContactList',
        label: 'Contacts',
        icon: 'address-card',
        value: content.props.list,
        onChange: this.applyUpdate((list, existing) => {
          const { props } = existing;
          return { ...existing, props: { ...props, list } };
        })
      }
    ]
  }
};

export default ContactListEditor;



// WEBPACK FOOTER //
// ./client/RLX/Views/Dashboard/Editors/ContactListEditor.jsx